import {
  DateTimeField,
  NumberField,
  RelationshipFieldMany,
  StringField,
} from "../plugins/Cruxtify/field-types";
import {
  DateTimeProperty,
  NumberProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class Attribute extends ApcCrudModel {
  public static icon = "mdi-tag-outline";
  protected static _typeLabel = "Attribute";
  protected static asProperty = "attribute";
  public static api = {
    path: "attributes",
  };

  protected static routeBase = "attributes";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "label",
        label: "Label",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "attribute_options",
        label: "Attribute Options",
        relatedModel: "AttributeOption",
        foreignProperty: "attribute",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: StringField, opts: { property: "label", isPrimaryLabelField: 1 } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "attribute_options",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["label", "created_at", "updated_at"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: ["label", "created_at", "updated_at"],
      },
      defaultSort: [
        {
          field: "label",
          order: "asc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "TabbedModelLayout",
      opts: {
        id: "tabs",
        tabs: [
          {
            id: "detailsTab",
            label: "Details",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                id: "attributeDetails",
                fieldSets: [
                  {
                    id: "main",
                    fields: ["label"],
                  },
                  {
                    id: "meta",
                    fields: ["created_at", "updated_at", "id"],
                  },
                ],
              },
            },
          },
          {
            id: "optionsTab",
            label: "Attribute Options",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                fieldSets: [
                  {
                    id: "options",
                    fields: ["attribute_options"],
                  },
                ],
              },
            },
          },
        ],
      },
    },
  ];
}
